import { Avatar, Badge, Box, IconButton } from "@mui/material";
import { X } from "lucide-react";
import React from "react";
import { useAuth } from "../../../../Reusable/AuthProvider";
import { useChat } from "../../../../Reusable/UseUserChat";
import { getChatOtherUser } from "../../../../Reusable/Utils";

interface ChatBubbleProps {
  usersKeyOrCertificationId: string;
}

export default function ChatBubble({
  usersKeyOrCertificationId,
}: ChatBubbleProps) {
  const { openChat, closeChat, conversationCache, messageCache } = useChat();
  const { user } = useAuth();
  const conversation = conversationCache[usersKeyOrCertificationId];

  // Calcul du nombre de messages non lus (envoyés par l'autre utilisateur)
  const messages = messageCache[usersKeyOrCertificationId]?.messages || [];
  const unreadCount = messages.filter(
    (msg) => msg.unread && msg.sender.id !== user?.id
  ).length;
  const badgeContent =
    unreadCount === 0 ? undefined : unreadCount > 9 ? "9+" : unreadCount;

  if (!conversation) return null;

  return (
    <Box
      onClick={() => openChat(usersKeyOrCertificationId)}
      sx={{
        position: "relative",
        width: 52,
        height: 52,
        cursor: "pointer",
        "&:hover .closeBtn": {
          opacity: 1,
        },
        // Cacher le badge au hover pour qu'il ne dépasse plus
        "&:hover .MuiBadge-badge": {
          opacity: 0,
        },
      }}
    >
      {/* Avatar + Badge */}
      <Badge
        badgeContent={badgeContent}
        color="error"
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          width: 52,
          height: 52,
          "& .MuiBadge-badge": {
            zIndex: 1,
          },
        }}
      >
        <Avatar
          src={getChatOtherUser(conversation, user?.id).imageUrl}
          sx={{
            width: 52,
            height: 52,
            boxShadow: 1,
            bgcolor: "background.paper",
          }}
        />
      </Badge>

      {/* Bouton de fermeture */}
      <IconButton
        className="closeBtn"
        onClick={(e) => {
          e.stopPropagation();
          closeChat(usersKeyOrCertificationId);
        }}
        sx={{
          position: "absolute",
          top: -4,
          right: -4,
          width: 20,
          height: 20,
          bgcolor: "grey.50",
          p: 0,
          opacity: 0,
          transition: "opacity 0.2s",
          zIndex: 2,
          "&:hover": {
            bgcolor: "grey.200",
          },
        }}
      >
        <X size={14} />
      </IconButton>
    </Box>
  );
}
